import { select, put, take } from 'redux-saga/effects';
import { RootState } from '../../..';
import { LocalStorageSave } from '../actions';
import { setToken, setCustomState } from '../../../reducer';
import { isPlainObject } from 'lodash';
import { TBaseDataItem, TBaseDataObject } from '../../../../types';

/**
 * Saga для отслеживания изменений jwt и states (ls-*) и сохранения в localStorage
 */
export function* watchAndSaveToLocalStorage(): Generator {
  // Подписываемся на изменения setToken и setCustomState
  while (true) {
    // Ждём изменения токена или состояния
    const actionUnknown = yield take([setToken.type, setCustomState.type]);
    const action = actionUnknown as unknown as
      | ReturnType<typeof setToken>
      | ReturnType<typeof setCustomState>;

    if (action.type === setToken.type) {
      // Сохраняем jwt
      const jwt = (action as ReturnType<typeof setToken>).payload;
      yield put(LocalStorageSave({ jwt }));
    } else if (action.type === setCustomState.type) {
      // Проверяем, начинается ли имя состояния на 'ls-'
      const { name } = (action as ReturnType<typeof setCustomState>).payload;
      if (name.startsWith('ls-')) {
        // Получаем все ls-* states из redux
        const states = (yield select((state: RootState) => {
          const allStates = state.ui.states;
          const lsStates: Record<
            string,
            TBaseDataItem | TBaseDataObject | TBaseDataItem[] | TBaseDataObject[]
          > = {};
          for (const [key, val] of Object.entries(allStates)) {
            if (key.startsWith('ls-')) {
              lsStates[key] = val;
            }
          }
          return lsStates;
        })) as unknown as Record<
          string,
          TBaseDataItem | TBaseDataObject | TBaseDataItem[] | TBaseDataObject[]
        >;

        // Сохраняем только если states не пустой объект
        if (isPlainObject(states) && Object.keys(states).length > 0) {
          yield put(LocalStorageSave({ states }));
        }
      }
    }
  }
}
